import UploadTrigger from "./upload-trigger";

export default UploadTrigger;
